<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_COMMUNITY_PUBLICATIONS"
    title="Publications"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Publications"
    align="center"
    width="full"
  >
    <iColumn v-if="publications?.length === 0">
      <iSpace :height="1" />
      <iText variant="subtle">
        No Publications Found.
      </iText>
    </iColumn>
    <SmartFeed
      :source="useCommunityPublicationFeedStore"
      default-entity-size="small"
      load-more-behavior="auto"
    />
    <AddToNetworkModal />
    <InvitePublicationModal />
  </PageWrapper>
</template>

<script>
import { mapActions, mapState } from "pinia";
import PageWrapper from "@/components/PageWrapper";
import { SECTION_COMMUNITY, PAGE_COMMUNITY_PUBLICATIONS } from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import SmartFeed from "SmartFeed/components/SmartFeedV2";
import { useCommunityPublicationFeedStore } from "@/smart-feed/stores/feed/community-publication-feed-store";
import InvitePublicationModal from "@/components/networks/InvitePublicationModal.vue";
import AddToNetworkModal from "@/components/networks/AddToNetworkModal.vue";
export default {
  name: "CommunityPublications",
  components: {
    AddToNetworkModal,
    InvitePublicationModal,
    PageWrapper,
    SmartFeed,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_COMMUNITY_PUBLICATIONS,
      hasMorePublications: true,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
      ];
    },
    ...mapState(useCreatorPublicationStore, [
      "communityPublications",
      "communityPublicationsLoading",
      "lastCommunityPublicationId",
      "hasMoreCommunityPublications",
    ]),
  },

  methods: {
    useCommunityPublicationFeedStore,
    ...mapActions(useCreatorPublicationStore, [
      "getCommunityPublications",
    ]),
    loadMorePublications() {
      this.getCommunityPublications();
    },
  },
};
</script>
